import { ApolloError } from '@apollo/client/errors';

import { MetricsStatus } from '../../../apis/graphql/types';

export const getDelayDatesString = (metricsStatus?: MetricsStatus): string => {
  if (!metricsStatus?.delay) return '';

  return metricsStatus.delay.startDate === metricsStatus.delay.endDate
    ? metricsStatus.delay.startDate
    : `${metricsStatus.delay.startDate}, to ${metricsStatus.delay.endDate}`;
};

export const getDelayDatesMessageToShow = (
  delayDatesString: string,
  viewedDates: string,
  error?: ApolloError
): string => {
  if (error) return 'Error occurred while fetching delay dates. Please try later.';
  return viewedDates !== delayDatesString && delayDatesString ? `Data for ${delayDatesString} is delayed` : '';
};

export const getLastUpdatedDateToShow = (metricsStatus?: MetricsStatus, error?: ApolloError): string =>
  error || !metricsStatus?.lastUpdated
    ? 'No data available at this time.'
    : `Last updated on ${metricsStatus.lastUpdated}`;
